import { Box, useDisclosure } from "@chakra-ui/react";
import { AnimatePresence } from "framer-motion";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { ScaleIn } from "../animate/scaleIn";
import { CustomDrawer } from "../chakra/modals";
import { Loader } from "../loaders";

const BaseLayout = () => {
  // const { pathname } = useLocation();

  const sideBarModal = useDisclosure();

  return (
    <>
      <AnimatePresence mode="wait">
        <ScaleIn key="layoutready" scale={1}>
          <Box>
            <AnimatePresence>
              <Suspense fallback={<Loader />}>
                <Outlet />
              </Suspense>
            </AnimatePresence>
          </Box>
        </ScaleIn>
      </AnimatePresence>

      {/* mobile sidebar */}
      <CustomDrawer
        disclosure={sideBarModal}
        size="md"
        drawerContentProps={{
          px: "2px",
          // bg: theme.bg,
        }}
        placement="left"
        isMenu
        hideOverlay
      >
        <Box>SIDE BAR HERE</Box>
      </CustomDrawer>
    </>
  );
};

export default BaseLayout;
